
export const TransactionStatus = {
  WAITING_FOR_DOWNLOAD: "WAITING_FOR_DOWNLOAD",
  WAITING_FOR_EMAIL: "WAITING_FOR_EMAIL",
  WAITING_FOR_PAYBACK: "WAITING_FOR_PAYBACK",
  DONE: "DONE"
}
